import React from 'react';

import { NoraTextAreaInput } from 'ethos-design-system';

import { Box, Button, Divider, Drawer, Typography } from '@mui/material';

import { FlexRow, NoraButton, Spacer } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import ElementLocators from '../../../../common/ElementLocators';
import styles from '../styles.module.scss';

interface IEditReinstatementDecisionProps {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  description: string;
  setDescription: (val: string) => void;
  showSummary: (val: boolean) => void;
  onReviewClick: () => void;
  drawerName: string;
}

export default function EditReinstatementDecision(
  props: IEditReinstatementDecisionProps,
) {
  return (
    <Drawer
      open={props.isOpen}
      anchor="right"
      variant="persistent"
      classes={{ paper: styles.Drawer }}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <Box mt={6}>
        <Box
          m={3}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">{props.drawerName}</Typography>
          <Button onClick={() => props.setIsOpen(false)}>
            <Typography variant="subtitle2" color="textSecondary">
              {Resource.CANCEL}
            </Typography>
          </Button>
        </Box>
        <Divider />
        <Box m={3}>
          <Spacer height={16} />
          <FlexRow className={styles.DrawerSubTitle}>
            {Resource.DESCRIPTION}
          </FlexRow>
          <FlexRow>
            <NoraTextAreaInput
              name={
                ElementLocators.LOCATOR_DASHBOARD_REINSTATEMENT_DECISION_DESCRIPTION
              }
              data-tid={
                ElementLocators.LOCATOR_DASHBOARD_REINSTATEMENT_DECISION_TEXTAREA
              }
              placeholder="Describe the reason"
              textClassName={styles.TextareaInput}
              onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
                props.setDescription(ev.currentTarget.value);
              }}
              value={props.description}
            />
          </FlexRow>
        </Box>
      </Box>
      <Box>
        <NoraButton
          name={ElementLocators.LOCATOR_REVIEW_APPROVAL_BUTTON}
          className={styles.DrawerButton}
          onClick={props.onReviewClick}
        >
          {Resource.REVIEW_DECISION}
        </NoraButton>
      </Box>
    </Drawer>
  );
}
